import React from 'react';
import { DataGrid } from '../../../common';
import StatusBadge from './StatusBadge';

const FlightScheduleTable = ({ flights, loading }) => {
  const columns = [
    {
      field: 'hubBase',
      headerName: 'Hub Base',
      minWidth: 110,
      flex: 1,
      cellClass: 'hub-cell',
      sortable: true,
      filterable: true,
      filterParams: {
        condition: 'equals',
      },
      cellRenderer: params => <span>{params.value}</span>,
    },
    {
      field: 'tail',
      headerName: 'Tail Number',
      minWidth: 140,
      flex: 1,
      sortable: true,
      cellRenderer: params => (
        <div className="tail-cell">
          <a
            href={`/operations/aircraftMaster?tail=${params.value}`}
            className="tail-link"
          >
            {params.value}
          </a>
        </div>
      ),
    },
    {
      field: 'sectorCode',
      headerName: 'Sector',
      minWidth: 160,
      flex: 1,
      cellRenderer: params => (
        <div className="flex gap-2 p-2 flex-column alignItemsStart justifyContentCenter">
          <span style={{ lineHeight: 1 }}>{params.value}</span>
          <span style={{ lineHeight: 1 }}>{params.data?.route}</span>
        </div>
      ),
    },
    {
      field: 'schedule',
      headerName: 'Schedule (STD/STA)',
      minWidth: 180,
      flex: 1,
      valueGetter: params =>
        `${params.data?.std || ''} / ${params.data?.sta || ''}`,
      cellRenderer: params => (
        <div className="flex gap-2 p-2 flex-column alignItemsStart justifyContentCenter">
          <span style={{ lineHeight: 1 }}>D: {params.data?.std}</span>
          <span style={{ lineHeight: 1 }}>A: {params.data?.sta}</span>
        </div>
      ),
    },
    {
      field: 'actual',
      headerName: 'Actual (ATD/ATA)',
      minWidth: 180,
      flex: 1,
      valueGetter: params =>
        `${params.data?.atd || ''} / ${params.data?.ata || ''}`,
      cellRenderer: params => {
        const isActualNA =
          params.data?.actualDep === 'N/A' || !params.data?.actualDep;
        const isActualDelayed = params.data?.isDelayed;

        return isActualNA ? (
          <span className="na-text">N/A</span>
        ) : (
          <div
            className={`flex gap-2 p-2 flex-column alignItemsStart justifyContentCenter ${isActualDelayed ? 'delayed-text' : ''}`}
          >
            <span style={{ lineHeight: 1 }}>D: {params.data?.atd}</span>
            <span style={{ lineHeight: 1 }}>A: {params.data?.ata}</span>
          </div>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 170,
      flex: 1,
      sortable: true,
      cellRenderer: params => (
        <StatusBadge
          status={params.data?.status}
          label={params.data?.statusLabel}
          note={params.data?.disruptionNote}
        />
      ),
    },
  ];

  return (
    <DataGrid
      columns={columns}
      columnResize
      enableGridSearch
      loading={loading}
      className="full-flex"
      getRowHeight={() => 50}
      rowData={flights}
      emptyMessage={
        <>
          {flights?.length === 0 && (
            <div className="empty-state">
              <h3 className="empty-title">No Flights Found</h3>
              <p className="empty-desc">
                Try widening your search terms or using a different operational
                update.
              </p>
            </div>
          )}
        </>
      }
      rowModelType="clientSide"
      pagination
      paginationPageSize={20}
      scrollbar
    />
  );
};

export default FlightScheduleTable;
